import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { IVehicleCardsFormValues } from 'features/Vehicles/types'

const tagMessages = defineMessages({
  max: {
    id: 'vehicles.form.cards.tag.max',
    defaultMessage: 'The tag id cannot be longer than {max} characters'
  }
})

const fuelMessages = defineMessages({
  max: {
    id: 'vehicles.form.cards.fuel.max',
    defaultMessage: 'The fuel id cannot be longer than {max} characters'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IVehicleCardsFormValues> => {
  return yup.object().shape({
    tagCards: yup.array().of(
      yup
        .string()
        .max(128, ({ max }) => intl.formatMessage(tagMessages.max, { max }))
        .required()
    ),
    fuelCards: yup.array().of(
      yup
        .string()
        .max(128, ({ max }) => intl.formatMessage(fuelMessages.max, { max }))
        .required()
    )
  })
}
